import { combineReducers } from "redux";
import typistWorklist from "./typistWorklistReducer";
import typistParked from "./typistParkedReducer";
import typistSubmitted from "./typistSubmittedReducer";
import typistWorkloadList from "./typistWorkloadListReducer";
import reportEditor from "./reportEditorReducer";

const typistReducer = combineReducers({
    worklist: typistWorklist,
    typistParked: typistParked,
    typistSubmitted: typistSubmitted,
    workloadList: typistWorkloadList,
    reportEditor: reportEditor,
});

export default typistReducer;
